import React from 'react'
import { CommonPublisherCountryFieldEntityOrSubEntity } from 'src/publisher/shared/components/field/common-publisher-country-field-entity-or-sub-entity'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { useFormField } from '../hooks/use-form-field'

interface FormCountryFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormCountryFieldSubEntity = ({
  fieldSubEntity,
}: FormCountryFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({ fieldSubEntity })
  return (
    <CommonPublisherCountryFieldEntityOrSubEntity
      entityOrSubEntity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
